/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Admin_Settings_Test_TitleInputs */

const en_admin_settings_test_title = /** @type {(inputs: Admin_Settings_Test_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test ${i?.group}`)
};

/**
* | output |
* | --- |
* | "Test {group}" |
*
* @param {Admin_Settings_Test_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_title = /** @type {((inputs: Admin_Settings_Test_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_TitleInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_test_title(inputs)
});
export { admin_settings_test_title as "admin.settings.test.title" }